import { render, staticRenderFns } from "./AttachmentPreviewField.vue?vue&type=template&id=9afeb940&scoped=true"
import script from "./AttachmentPreviewField.vue?vue&type=script&lang=js"
export * from "./AttachmentPreviewField.vue?vue&type=script&lang=js"
import style0 from "./AttachmentPreviewField.vue?vue&type=style&index=0&id=9afeb940&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afeb940",
  null
  
)

export default component.exports